export default "__VITE_ASSET__DOxErWrW__"